import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../../Modal/Modal';
import classes from '../style.module.scss';
import { ReactComponent as ChooseFileIcon } from '../../../../assets/icons/chooseFile.svg';
import { ReactComponent as PdfIcon } from '../../../../assets/icons/pdf.svg';
import { ReactComponent as FileIcon } from '../../../../assets/icons/file.svg';
import Select from '../../Form/Selects/Select/Select';
import Button from '../../Form/Buttons/Button';

function ModalAttachedFile({
  onSaveFile, onCloseModal, onChangeFile, open, sendFile, typeOptions, setSendFile, type, btnLoad,
}) {
  return (
    <Modal
      open={open}
      onClose={onCloseModal}
      className={classes.doc_modal}
    >

      <div className={classes.modal_wrapper}>
        <form>
          <p>{type === 'script' ? 'Select file' : 'Select PDF'}</p>
          <label htmlFor="file">
            <ChooseFileIcon />
            {type === 'script' ? <FileIcon /> : <PdfIcon />}
            {sendFile.fileName && <p>{sendFile.fileName}</p>}
          </label>

          <input
            type="file"
            id="file"
            accept={type === 'script' ? ' file_extension' : '.pdf'}
            onChange={(e) => onChangeFile(e.target.files[0])}
          />
        </form>

        <div className={classes.select_wrapper}>
          <Select
            label="Select type"
            onChange={(option) => { setSendFile((prev) => ({ ...prev, type: option })); }}
            currentOption={sendFile.type}
            options={typeOptions}
            zIndex={30}
          />
        </div>

        <div className={classes.btn_wrapper}>
          <Button
            title="Cancel"
            type="button"
            onClick={onCloseModal}
            clearButton
          />

          <Button
            title="Ok"
            type="button"
            loading={btnLoad}
            onClick={onSaveFile}
          />
        </div>

      </div>
    </Modal>
  );
}

ModalAttachedFile.propTypes = {
  onSaveFile: PropTypes.func.isRequired,
  setSendFile: PropTypes.func.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  onChangeFile: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  btnLoad: PropTypes.bool.isRequired,
  sendFile: PropTypes.object.isRequired,
  typeOptions: PropTypes.array.isRequired,
  type: PropTypes.string,

};

ModalAttachedFile.defaultProps = {
  type: '',
};

export default ModalAttachedFile;
